import { parseISO } from 'date-fns';
import { format } from 'date-fns/format';
import { useMemo } from 'react';

import { MediaVideo } from '#components/Media/MediaVideo';
import type { BR24In100Seconds } from '#domains/resolver/board-section-data';
import { logger } from '#utils/logging/logger';

import { IMAGE_SIZE_ONE_THIRD } from '../../BoardImageSizes';

import styles from './BoardSectionItemBR24In100Seconds.module.scss';

type Props = {
	newsVideo: BR24In100Seconds | null | undefined;
};

export function BoardSectionItemBR24In100Seconds({ newsVideo }: Props) {
	// eslint-disable-next-line react-hooks/preserve-manual-memoization
	const formattedDate = useMemo(() => {
		if (newsVideo?.updateDate) {
			return format(parseISO(newsVideo.updateDate), "dd.MM.yyyy, HH:mm 'Uhr'");
		} else {
			return '';
		}
	}, [newsVideo?.updateDate]);

	if (!newsVideo) {
		logger.error(`'newsVideo' not found for BoardSectionItemBR24In100Seconds`);

		return null;
	}

	const duration = !!newsVideo.duration ? Math.ceil(newsVideo.duration) : undefined;
	const publicationDate = newsVideo.updateDate;

	const posterImageTitle = (
		<div className={`body7 ${styles.title}`}>
			<div className="heading3">BR24 100 Sekunden</div>
			{formattedDate && <div>{formattedDate}</div>}
		</div>
	);

	return (
		<section className={styles.wrapper}>
			<header className={styles.header}>
				<MediaVideo
					duration={duration}
					publicationDate={publicationDate}
					thumbnailAltText={`BR24 100 Sekunden vom ${formattedDate}`}
					thumbnailUrl={newsVideo.thumbnail}
					title={newsVideo.title}
					url={newsVideo.url}
					mimeType="video/mp4"
					posterImageTitle={posterImageTitle}
					playButtonTitle={`BR24 100 Sekunden vom ${formattedDate} abspielen`}
					sizes={IMAGE_SIZE_ONE_THIRD}
					moduleId={100100}
				/>
			</header>
		</section>
	);
}
